import { SurveyActions } from '@r1-frontend/survey/context/constants/actions';
import { SurveyItem } from '@r1-frontend/survey/context/surveys';

import { IAction } from '@r1-frontend/shared/types/Redux';

const setContextSurvey = (survey: SurveyItem): IAction<SurveyActions.SetContextSurvey, { survey: SurveyItem }> => ({
    type: SurveyActions.SetContextSurvey,
    payload: {
        survey,
    },
});

export default setContextSurvey;
